import detectIt from 'detect-it';

export default function() {
    
    // Определение тач устройств

    if (detectIt.hasTouch) {
        document.body.classList.remove('no-touch-dev');
        document.body.classList.add('touch-dev');
    }
    else{
        document.body.classList.remove('touch-dev');
        document.body.classList.add('no-touch-dev');
    }


    var iOS = (navigator.userAgent.match(/(iPad|iPhone|iPod)/i) && !navigator.userAgent.match(/(Windows\sPhone)/i)) ? true : false;
    var Android = (navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/(Windows\sPhone)/i)) ? true : false;

    if(iOS || Android){
        document.body.classList.add('mobile-dev');
    }

}
